// extracted by mini-css-extract-plugin
export default {"newModal":"modals-NewConfirmationModal-_style-module_newModal","text":"modals-NewConfirmationModal-_style-module_text","buttons":"modals-NewConfirmationModal-_style-module_buttons"};